// removed by extract-text-webpack-plugin
module.exports = {"loading":"Loading-loading-1r10b","loadingIndicator":"Loading-loadingIndicator-oSbl-"};


//////////////////
// WEBPACK FOOTER
// ./modules/issFrontend/styles/Loading.styl
// module id = ./modules/issFrontend/styles/Loading.styl
// module chunks = 1